import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const emptyParkingDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "empty-parking-detect-example",
  version: 1,
  title: "Smart parking",
  description: "Find open spaces",
  subdescription: "Identify which parking spaces are free in a crowded lot.",
  thumbnailUuid: BASE_ASSETS.emptyParkingSpotsExample.uuid,
  assets: [BASE_ASSETS.emptyParkingSpotsExample],
  detect: {
    mediaUuid: BASE_ASSETS.emptyParkingSpotsExample.uuid,
    categories: ["empty parking spots", "cars"],
    config: {
      output: "box",
      enableThinking: true,
    },
  },
};
